const translations = {
  page_title: 'Deals',
  header_title: 'New deal',

  vehicle: 'Vehicle',
  buyer: 'Buyer',
  deal: 'Deal',

  select_from_leads: 'Select from leads',
  select_lead: 'Select a lead',
  invalid_lead: 'Invalid lead',
  add_new_lead: 'Add new lead',
  or: 'or',

  type: 'Type',
  type_placeholder: 'Type',
  invalid_type: 'Invalid type',

  date_of_birth: 'Date of birth',
  down_payment: 'Down payment',
  down_payment_method: 'Down payment method',
  sales_manager: 'Sales manager',
  finance_manager: 'Finance manager',
  salesman_1: 'Salesman 1',
  salesman2: 'Salesman 2',

  invalid_value: 'Invalid value',

  financiamiento: 'Financing',
  institucion: 'Institution',
  institucion_placeholder: 'Select institution',
  financed_term: 'Term',
  financed_term_placeholder: 'Enter term',
  monto_a_financiar: 'Financing amount',
  monto_a_financiar_placeholder: 'Enter amount',
  apr: 'APR',
  apr_placeholder: 'APR',

  sale_price: 'Sale price',

  start_deal: 'Start deal',
  view_details: 'View details',

  down_payment_error: 'Down payment must be less than sale price',
  salesman_error: 'Salesman 1 and Salesman 2 cannot be the same',

  deal_created: 'Deal created successfully',

  first_name_placeholder: 'e.g. Juan Carlos',
  last_name_placeholder: 'e.g. Gonzales',
  birthdate_placeholder: 'Select the birth date',
  email_placeholder: 'e.g. juancarlos@email.com',
  phone_placeholder: 'e.g. 787 000 0000',

  price_placeholder: 'e. g. $10,000',
  deal_type_placeholder: 'Select a deal type',
  down_payment_placeholder: 'e.g. $10,000',
  down_payment_method_placeholder: 'Select a payment method',
  sales_manager_placeholder: 'Select a sales manager',
  finance_manager_placeholder: 'Select a finance manager',
  salesman_1_placeholder: 'Select a salesperson',
  salesman_2_placeholder: 'Select a second salesperson',
};

export default translations;
